import {
  SET_ACTIVE_PROJECT
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_PROJECT:
      return action.payload;

    default:
      return state;
  }
}